<template>
        <div id='article'>
              <NavTop :title='article.title'/>
              <div class='content' v-html="article.content">
              </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop' 
export default {
  data(){
      return{
         article:{}
      }
  },  
  name: 'Article',
  created(){
     this.getArticle()
  },
  methods:{
     getArticle(){
        if(this.$route.params.type==undefined){
             this.$toast("页面参数有误，请稍后再试")
             return false
        } 
        this.$post("/article/getArticle",{type:this.$route.params.type}).then((data)=>{
               if(data.result.success){
                  this.article=data.result.info
               }else{
                 this.$toast(data.result.info)
               }
           })   
     }
  },
  components:{
      NavTop
  }
}
</script>
<style scoped>
#article{background-color:#F6F6F6;min-height: 100vh;}
.content{font-size:0.5rem;overflow-x:hidden;word-break:break-all;text-align: left;padding: 0.35rem;}
</style>


